import React from 'react';
import { css } from 'glamor';
import { toast } from 'react-toastify';
import { Notification } from 'components/Base';

const options = {
  className: css({
    background: '#fff !important',
    padding: '0 !important',
    minHeight: 'unset !important'
  })
};

export default {
  success(msg: string, info?: string) {
    return toast.success(
      <Notification type="success" msg={msg} info={info} />,
      options
    );
  },
  warn(msg: string, info?: string) {
    return toast.success(
      <Notification type="warn" msg={msg} info={info} />,
      options
    );
  },
  info(msg: string, info?: string) {
    return toast.success(
      <Notification type="info" msg={msg} info={info} />,
      options
    );
  },
  error(msg: string, info?: string) {
    if (!msg) {
      const emptyErrMsg = 'Unknown Error';
      const emptyMsgDesc = 'Please contact administrator';
      return toast.success(
        <Notification type="error" msg={emptyErrMsg} info={emptyMsgDesc} />,
        options
      );
    }

    return toast.success(
      <Notification type="error" msg={msg} info={info} />,
      options
    );
  }
};
